import Vue from "vue";
import VueRouter from "vue-router";
import TheContainer from "@/containers/TheContainer";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Container",
    component: TheContainer,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("@/views/home/HomeView"),
      },
      {
        path: "aboutUs",
        name: "AboutUs",
        component: () => import("@/views/about"),
      },
      {
        path: "support",
        name: "Support",
        component: () => import("@/views/support"),
      },
      {
        path: "rules",
        name: "Rules",
        component: () => import("@/views/rules"),
      },
      {
        path: "blog",
        name: "Blogs",
        component: () => import("@/views/blogs"),
      },
      {
        path: "blog/:id/:title",
        name: "Blog",
        component: () => import("@/views/blogs/BlogPage"),
      },
      {
        path: "contactUs",
        name: "ContactUs",
        component: () => import("@/views/contactUs"),
      },
      {
        path: "tutorials",
        name: "Tutorials",
        component: () => import("@/views/tutorials"),
      },
      {
        path: "tutorial/:id/:title",
        name: "Tutorial",
        component: () => import("@/views/tutorials/TutorialPage"),
      },
      {
        path: "products",
        name: "Products",
        component: () => import("@/views/products/index.vue"),
      },
      {
        path: "product/:id/:title",
        name: "ProductDetails",
        component: () => import("@/views/products/ProductPage.vue"),
      },
      {
        path: "/gallery",
        redirect: "/gallery/list",
        name: "Gallery",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "list",
            name: "GalleryList",
            component: () => import("@/views/gallery"),
          },
          {
            path: "image/:id/:title",
            name: "ImageGallery",
            component: () => import("@/views/gallery/ImageGallery"),
          },
          {
            path: "video/:id/:title",
            name: "VideoGallery",
            component: () => import("@/views/gallery/VideoGallery"),
          },
          {
            path: "sound/:id/:title",
            name: "SoundGallery",
            component: () => import("@/views/gallery/SoundGallery"),
          },
        ],
      },
      {
        path: "services/:id",
        name: "Services",
        component: () => import("@/views/services/ServicePage"),
      },
      {
        path: "/page/:key",
        name: "DynamicPage",
        component: () => import("@/views/pages/index.vue"),
      },

      {
        path: "login",
        name: "UserLogin",
        component: () => import("@/views/authentication"),
        beforeEnter(to, from, next) {
          if (localStorage.getItem("panelToken")) {
            next({ name: "PanelDashboard" });
          } else {
            next();
          }
        },
      },
      {
        path: "job",
        meta: {
          label: "کاریابی و استخدام",
          requiresAuth: false,
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/requests",
        children: [
          {
            path: "requests",
            name: "Request&AdvertisemeJobs",
            meta: {
              requiresAuth: false,
              label: "استخدام و کاریابی",
            },
            component: () => import("@/views/job/index"),
          },
          {
            path: "advertisemeJobs/detail/:id",
            name: "JobAdvertisemeDetails",
            meta: {
              requiresAuth: false,
              label: "استخدام و کاریابی",
            },
            component: () => import("@/views/job/Detail"),
          },
          {
            path: "requestJobs/detail/:id",
            name: "RequestDetail",
            meta: {
              requiresAuth: false,
              label: "استخدام و کاریابی",
            },
            component: () => import("@/views/job/RequestDetail"),
          },
        ],
      },

      {
        path: "/panel",
        redirect: "/panel/dashboard",
        name: "UserPanel",
        component: () => import("@/containers/PanelSidebar"),
        children: [
          {
            path: "dashboard",
            name: "PanelDashboard",
            meta: {
              label: "داشبورد پنل کاربری",
              requiresAuth: true,
            },
            component: () => import("@/views/panel/Dashboard"),
          },
          {
            path: "profile",
            name: "PanelProfile",
            meta: {
              label: "ویرایش پروفایل کاربری",
              requiresAuth: true,
            },
            component: () => import("@/views/panel/Profile"),
          },
          {
            path: "/ticket",
            name: "Ticket",
            meta: {
              label: "تیکت پشتیبانی",
              requiresAuth: true,
            },
            component: () => import("@/views/panel/Ticket"),
          },
          {
            path: "job",
            meta: {
              label: "کاریابی و استخدام",
              requiresAuth: true,
            },
            component: {
              render(c) {
                return c("router-view");
              },
            },
            redirect: "/requests",
            children: [
              {
                path: "requests",
                name: "PanelRequest&AdvertisemeJobs",
                meta: {
                  requiresAuth: true,
                  label: "استخدام و کاریابی",
                },
                component: () => import("@/views/panel/job/index"),
              },
              {
                path: "advertiseme/add",
                name: "AddAdvertisemePanel",
                meta: {
                  requiresAuth: true,
                  label: "افزودن آگهی استخدام",
                },
                component: () => import("@/views/panel/job/advertiseme/Add"),
              },
              {
                path: "advertiseme/edit/:id",
                name: "EditAdvertisemePanel",
                meta: {
                  requiresAuth: true,
                  label: "ویرایش آگهی استخدام",
                },
                component: () => import("@/views/panel/job/advertiseme/Edit"),
              },
              {
                path: "requests/detail/:id",
                name: "PanelJobRequestDetails",
                meta: {
                  requiresAuth: true,
                  label: "استخدام و کاریابی",
                },
                component: () => import("@/views/panel/job/advertiseme/Detail"),
              },
              {
                path: "requests/add",
                name: "AddJobRequestPanel",
                meta: {
                  requiresAuth: true,
                  label: "افزودن آگهی کاریابی",
                  redirect: false
                },
                component: () => import("@/views/panel/job/request/Add"),
              },
              {
                path: "requests/edit/:id",
                name: "EditJobRequestPanel",
                meta: {
                  requiresAuth: true,
                  label: "ویرایش آگهی کاریابی",
                },
                component: () => import("@/views/panel/job/request/Edit"),
              },
            ],
          },
         // end of Users Panel
        ],
      },

        
     // end of containers
    ],
  },

  {
    path: "/warn",
    name: "Warn",
    component: {
      render(c) {
        return c("router-view");
      },
      redirect: "/warn/404",
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
